import {reject, partialRight, nthArg, pick, sortBy, groupBy, mapValues, minutes, createSelector} from 'helpers';
import {day} from './day';
import {current} from 'store/activities/selectors';
import {type, today} from 'store/common';
import {isNight} from 'store/session';

export const missed = createSelector(
  [ nthArg(1) ],
  ( obj ) => obj?.missed
);

export const scheduled = createSelector(
  [ nthArg(1) ],
  ( obj ) => obj?.scheduled
);

export const routinePlanDate = createSelector(
  [ today, type, isNight ],
  ( today, type, isNight ) => (type == 'morning' || isNight) ? today : today.clone().add(1, 'day')
);

export const routinePlanPreviousDate = createSelector(
  [ routinePlanDate ],
  ( date ) => date.clone().subtract(1, 'day')
);

export const routinePlanMissed = createSelector(
  [ day ],
  ( activities ) => activities.filter(({ repeatType, status }) => repeatType && status == 'Missed')
);

export const routinePlanScheduled = createSelector(
  [ day ],
  ( activities ) => activities.filter(({ repeatType }) => repeatType)
);

export const routinePlan = createSelector(
  [ current.onetime, routinePlanDate, missed, scheduled, routinePlanPreviousDate ],
  ( onetime, date, missed, scheduled, previousDate ) => {
    let groups = groupBy(onetime, ({ status, ts }) => {
      if (status == 'Not Started') {
        if (!ts) {
          return 'No Date';
        } else if (ts != date.unix()) {
          return ts > date.unix() ? 'Future' : 'Missed';
        }
      }
    });
    missed = reject(missed, ({ id }) => scheduled.find(activity => activity.id == id));
    if (missed.length) {
      groups.Missed = groups.Missed || [];
      groups.Missed = groups.Missed.concat(missed);
    }
    groups = mapValues(groups, group => {
      return sortBy(group, partialRight(byDateTime, { previousDate }), 'name');
    })
    groups = pick(groups, 'Missed', 'No Date', 'Future');
    if (groups.Missed) {
      groups.Missed.reverse();
    }
    return { groups, date };
  }
);

function byDateTime({ ts, time }, { previousDate }) {
  return (ts || previousDate.unix()) + minutes(time);
}
